import React, { PropTypes } from 'react';
import { InputField } from 'components';
import { proxyCounterpart } from '../../../scripts/proxyCounterpart';
import Translate from 'react-translate-component';

export class ContactInformation extends React.Component {

  static propTypes = {
    userData: PropTypes.object.isRequired,
    showErrorWithoutBlur: PropTypes.bool.isRequired,
    callback: PropTypes.func.isRequired
  };

  render () {
    return (<div className='modal-information-container'>
      <div className='input-row-container'>
        <Translate
          className='invoicing-description'
          content='COMPLETE_INFORMATION_ORDER_TOOL_CONTACT_INFO_DESCRIPTION'
        />
      </div>
      <div className='input-row-container'>
        <InputField
          type='tel'
          name='cellphone'
          value={this.props.userData.cellphone.value}
          placeholder={proxyCounterpart('TELEPHONE_NR')}
          callback={this.props.callback}
          required='true'
          minLength='2'
          errorMessage={proxyCounterpart('TELEPHONE_ERROR')}
          showErrorWithoutBlur={this.props.showErrorWithoutBlur}
        />
        <InputField
          type='text'
          name='street'
          value={this.props.userData.street.value}
          placeholder={proxyCounterpart('STREET_ADDRESS')}
          callback={this.props.callback}
          required='true'
          minLength='2'
          errorMessage={proxyCounterpart('ADDRESS_ERROR')}
          showErrorWithoutBlur={this.props.showErrorWithoutBlur}
        />
      </div>
      <div className='input-row-container'>
        <InputField
          type='text'
          name='city'
          value={this.props.userData.city.value}
          placeholder={proxyCounterpart('CITY')}
          callback={this.props.callback}
          required='true'
          minLength='2'
          errorMessage={proxyCounterpart('CITY_ERROR')}
          showErrorWithoutBlur={this.props.showErrorWithoutBlur}
        />
        <InputField
          type='text'
          name='zip'
          value={this.props.userData.zip.value}
          placeholder={proxyCounterpart('POSTAL_CODE')}
          callback={this.props.callback}
          required='true'
          minLength='2'
          errorMessage={proxyCounterpart('POSTAL_CODE_ERROR')}
          showErrorWithoutBlur={this.props.showErrorWithoutBlur}
        />
      </div>
    </div>);
  }
}

export default ContactInformation;



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/complete-information-modal/contact-information.js
 **/